/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
export const updateBodPayloadSchema = z.object({
    bod_simulation: z.object({
        notes: z.string(),
        scenario_id: z.string(),
        as_built_design: z.boolean(),
        por_design: z.boolean(),
    }),
    project: z.object({
        pv: z.object({
            pv_ac_design_capacity: z.number().nullable(),
            pv_dc_capacity_mw_dc: z.number().nullable(),
            pv_config_id: z.string().nullable(),
            pv_config_version: z.number().nullable(),
            module_price: z.number().nullable(),
            module_wattage: z.number().nullable(),
            tilt: z.number().nullable(),
            gcr: z.number().nullable(),
            ilr: z.number().nullable(),
            pv_epc_costs_per_k_w_dc: z.number().nullable(),
            first_year_production: z.number().nullable(),
            pv_annual_om_per_k_w_dc: z.number().nullable(),
            design_acreage: z.number().nullable(),
            racking: z.string().nullable(),
            power_factor: z.number().nullable(),
            power_factor_required_at: z.string().nullable(),
            pv_manufacturer: z.string().nullable(),
            pv_technology: z.string().nullable(),
        }),
        ess: z
            .object({
            ess_config_id: z.string().nullable(),
            ess_config_version: z.number().nullable(),
            storage_capacity_mwh_ac: z.number(),
            power: z.number(),
            technology_li_ion: z.string(),
            manufacturer: z.string(),
            first_year_cycles: z.number(),
            total_capex_k_wh_ac: z.number(),
            annual_o_m: z.number(),
        })
            .nullable(),
        weather: z.object({
            id: z.string().nullable(),
            utc_offset: z.number().nullable(),
        }),
    }),
});
export const removeBodPayloadSchema = z.object({
    scenario_id: z.uuid(),
    bod_id: z.string(),
});
//# sourceMappingURL=basis-of-design.js.map